export default __webpack_public_path__ + "static/media/01.202fda2f.jpg";